(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("cb-components-common"));
	else if(typeof define === 'function' && define.amd)
		define("cb-components-manager-tagging", ["cb-components-common"], factory);
	else if(typeof exports === 'object')
		exports["cb-components-manager-tagging"] = factory(require("cb-components-common"));
	else
		root["cb-components-manager-tagging"] = factory(root["cb-components-common"]);
})(self, function(__WEBPACK_EXTERNAL_MODULE_cb_components_common__) {
return 